import React, { useEffect, useState } from 'react';
import FooterComponent from './FooterComponent';
import HeaderMenu from '../components/HeaderMenu';
import formatString from "format-string-by-pattern";
import { FullUrlget, post } from '../helpers/api.helper';
import { toast } from 'react-toastify';


import $ from 'jquery';
import jQuery from 'jquery';
window.$ = jQuery;


const CpfValidator = require('cpf-cnpj-validator');


export default function CadastroRevendedor(props) {
    const [nome, setNome] = useState('');
    const [cpf, setcpf] = useState('');
    const [cpfInvalid, setInvalidcpf] = useState(false);
    const [cep, setcep] = useState('');
    const [cepResultSearch, setcepResultSearch] = useState(undefined);
    const [isLoader, setIsloader] = useState(false);
    const [acceptTerms, setacceptTerms] = useState(undefined);

    const [endereco, setendereco] = useState('');
    const [numero, setnumero] = useState('');
    const [bairro, setbairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [estado, setEstado] = useState('');

    const [telFixo, setTelFixo] = useState('');
    const [telCelular, setTelCelular] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [confirmSenha, setconfirmSenha] = useState('');
    const [divergentPasswords, setDivergentPasswords] = useState(false);


    useEffect(() => {
        $(document).ready(function () {
            $('.submit-btn').click(function () {
                $('.submit-btn').addClass('spinner-border spinner-border-sm');
            });
        });
    }, []);

    const cpfHandleChange = (value) => {
        let isValid = CpfValidator.cpf.isValid(value);
        if (!isValid) setInvalidcpf(true);
        else setInvalidcpf(false);


        let formatCpf = formatString('000.000.000-00', value);
        setcpf(formatCpf);
    }

    const cepHandleChange = async (value) => {
        let formatCep = formatString('00000-000', value);
        if (value.length === 9) {
            let unformatedCep = value.replace('.', '').replace('-', '');


            let resultCpf = await FullUrlget(`http://viacep.com.br/ws/${unformatedCep}/json/`);
            let { data } = resultCpf;
            setcepResultSearch(resultCpf);

            //set all values end with cep search
            setendereco(data.logradouro);
            setbairro(data.bairro);
            setEstado(data.uf);
            setCidade(data.localidade);
        }
        else {
            setcepResultSearch(undefined);
        }

        setcep(formatCep);
    }

    const phoneHandleChange = (value) => {
        let formatPhone = formatString('(00)0000-0000', value);
        setTelFixo(formatPhone)
    }

    const mobilePhoneHandleChange = (value) => {
        let formatMobile = formatString('(00)00000-0000', value);
        setTelCelular(formatMobile);
    }

    const setConfirmHandleChange = (value) => {
        setconfirmSenha(value);
    }

    const confirmSenhaTest = (value) => {
        setconfirmSenha(value);

        if (senha !== confirmSenha) {
            setDivergentPasswords(true);
        }
        else {
            setDivergentPasswords(false);
        }
    }

    const handleCheckedChange = (value)=>{
        setacceptTerms(value.target.checked);
    }


    const handleOnclick = async () => {
        try {
            setIsloader(true);
            


            let values = {
                nome: nome,
                cpf: cpf,
                cep: cep,
                endereco: endereco,
                numero: numero,
                bairro: bairro,
                cidade: cidade,
                estado: estado,
                telFixo: telFixo,
                telCelular: telCelular,
                email: email,
                senha: senha
            }

            if(!acceptTerms){
                toast.warning('É necessário concordar com os termos de uso para prosseguir!');
                setIsloader(false);
                return 
            }
            if(!nome){
                toast.info('Campo nome não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!cpf){
                toast.info('Campo CPF não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!cep){
                toast.info('Campo CEP não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!endereco){
                toast.info('Campo Endereço não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!numero){
                toast.info('Campo Número não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!bairro){
                toast.info('Campo Bairro não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!cidade){
                toast.info('Campo nome não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!estado){
                toast.info('Campo Estado não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!telFixo){
                toast.info('Campo Telefone fixo não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!telCelular){
                toast.info('Campo Telefone celular não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!email){
                toast.info('Campo Email não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!senha){
                toast.info('Campo Senha não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!confirmSenha){
                toast.info('Campo Confirmação da senha não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!acceptTerms){
                toast.info('Campo Confirmação da senha não pode ser vazio!');
                setIsloader(false);
                return 
            }


            let result = await post('usuario', values);

            if (result.status === 200) {
                toast.success('Obrigado por se cadastrar pra ser um de nossos revendedores. Em breve entraremos em contato.');
                props.navigate("/");
            }
            else if (result.status === 400) {
                toast.warning('Ocorreu um erro ao enviar suas informações');
            }
            setIsloader(false);
        } catch (error) {
            setIsloader(false);
            toast.warning('Ocorreu um erro ao enviar suas informações');
        }
    }

    return (
        <div>
            <div>
                <>
                    <HeaderMenu />


                    {/* Masthead*/}
                    <section className="page-section bg-primary" id="about">
                        <div className="container">
                            <div className="row h-100 align-items-center justify-content-center text-center">
                                <div className="col-lg-10 align-self-end">
                                    <h1 className="text-uppercase text-white font-weight-bold">Seja nosso revendedor</h1>
                                    <hr className="divider my-4" />
                                </div>
                                <div className="col-lg-8 align-self-baseline">

                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="page-section" id="contact">
                        <div className="container">
                            <form>
                                <div className="row">
                                    <div className="col-9">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Nome</label>
                                            <input type="text" className="form-control" aria-describedby="nomeHelp" name="nome" value={nome} onChange={(e) => setNome(e.target.value)} />
                                            {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">CPF</label>
                                            <input type="text" className="form-control" aria-describedby="emailHelp" value={cpf} onChange={(e) => cpfHandleChange(e.target.value)} />
                                            {
                                                cpfInvalid &&
                                                <small id="emailHelp" className="form-text text-muted "><span className="text-danger">CPF inválido.</span></small>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">CEP</label>
                                            <input type="text" className="form-control" aria-describedby="emailHelp" value={cep} onChange={(e) => cepHandleChange(e.target.value)} />
                                            {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Endereço</label>
                                            <input type="text" readOnly={cepResultSearch ? true : false} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" value={endereco} onChange={(e) => setendereco(e.target.value)} />
                                            {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Número</label>
                                            <input type="text" className="form-control" aria-describedby="emailHelp" value={numero} onChange={(e) => setnumero(e.target.value)} />
                                            {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                        </div>
                                    </div>

                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Bairro</label>
                                            <input type="text" readOnly={cepResultSearch ? true : false} className="form-control" aria-describedby="emailHelp" value={bairro} onChange={(e) => setbairro(e.target.value)} />
                                            {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Cidade</label>
                                            <input type="text" readOnly={cepResultSearch ? true : false} className="form-control" aria-describedby="emailHelp" value={cidade} onChange={(e) => setCidade(e.target.value)} />
                                            {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Estado</label>
                                            <input type="text" readOnly={cepResultSearch ? true : false} className="form-control" aria-describedby="emailHelp" value={estado} onChange={(e) => setEstado(e.target.value)} />
                                            {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                        </div>
                                    </div>
                                </div>


                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Telefone Fixo</label>
                                            <input type="text" className="form-control" aria-describedby="emailHelp" value={telFixo} onChange={(e) => phoneHandleChange(e.target.value)} />
                                            {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Telefone Celular</label>
                                            <input type="text" className="form-control" aria-describedby="emailHelp" value={telCelular} onChange={(e) => mobilePhoneHandleChange(e.target.value)} />
                                            {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                        </div>
                                    </div>
                                </div>


                                <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">Email</label>
                                    <input type="email" className="form-control" aria-describedby="emailHelp" value={email} onChange={(e) => setEmail(e.target.value)} />
                                    {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputPassword1">Senha</label>
                                            <input type="password" className="form-control" value={senha} onChange={(e) => setSenha(e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputPassword1">Confirmar Senha</label>
                                            <input type="password" className="form-control" value={confirmSenha} onKeyUp={(e) => confirmSenhaTest(e.target.value)} onChange={(e) => setConfirmHandleChange(e.target.value)} />
                                            {
                                                divergentPasswords &&
                                                <small id="emailHelp" className="form-text text-muted "><span className="text-danger">Senha e confirmação de senha não podem ser diferentes.</span></small>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group form-check">
                                    <input type="checkbox" checked={acceptTerms} onChange={(e) => handleCheckedChange(e)} className="form-check-input" id="exampleCheck1" />
                                    <label className="form-check-label" htmlFor="exampleCheck1">Li e Concordo com os termos e informações e declaro válidas todas informações inseridas. </label>
                                </div>
                                <button type="button" id="submit-btn" className={`btn btn-primary`} onClick={() => handleOnclick()} ><span className={isLoader ? ' spinner-border spinner-border-sm' : ''}></span> Enviar</button>
                            </form>
                        </div>
                    </section>
                </>
                <FooterComponent />
            </div>
        </div>
    )
}
